(function(){
  const state=new WeakMap();
  let ticking=false;

  function normalizeDate(value){
    if(!value) return "";
    return String(value).trim().split("T")[0];
  }

  function formatDate(value){
    const d=normalizeDate(value);
    if(!d) return "";

    const parts=d.split("-");
    if(parts.length!==3) return "";

    const date=new Date(parts[0],parts[1]-1,parts[2]);
    if(isNaN(date)) return "";

    return date.toLocaleDateString("es-CL",{
      day:"2-digit",
      month:"long",
      year:"numeric"
    });
  }

  function getVariantId(container,variants){
    const scope=container.closest('form[action*="/cart"]')||document;

    const radio=scope.querySelector('input[type="radio"][data-variant-id]:checked');
    if(radio&&radio.dataset.variantId) return String(radio.dataset.variantId);

    const select=scope.querySelector('select[name*="variant"],select[name="id"]');
    if(select&&select.value) return String(select.value);

    const hidden=scope.querySelector('input[name="id"]');
    if(hidden&&hidden.value) return String(hidden.value);

    if(container.dataset.initialVariantId) return String(container.dataset.initialVariantId);

    if(variants.length===1&&variants[0].id) return String(variants[0].id);

    return null;
  }

  function updateContainer(container){
    const output=container.querySelector("[data-dispatch-date]");
    if(!output) return;

    const productDate=normalizeDate(container.dataset.productDate);

    let variants=[];
    try{
      variants=JSON.parse(container.dataset.variantDates||"[]");
    }catch(e){
      variants=[];
    }

    const map={};

    for(const variant of variants){
      if(!variant||!variant.id) continue;
      map[String(variant.id)]=normalizeDate(variant.date);
    }

    const variantId=getVariantId(container,variants);

    let rawDate="";

    if(variantId&&map[variantId]){
      rawDate=map[variantId];
    }else if(productDate){
      rawDate=productDate;
    }else{
      rawDate="";
    }

    const formatted=formatDate(rawDate);
    const visible=!!formatted;
    const previous=state.get(container)||{variantId:null,date:null,visible:null};

    if(previous.variantId===variantId&&previous.date===formatted&&previous.visible===visible){
      return;
    }

    state.set(container,{
      variantId:variantId,
      date:formatted,
      visible:visible
    });

    if(!formatted){
      if(container.style.display!=="none") container.style.display="none";
      return;
    }

    if(output.textContent!==formatted) output.textContent=formatted;
    if(container.style.display==="none") container.style.display="";
  }

  function run(){
    document.querySelectorAll(".preorder-dispatch-message").forEach(updateContainer);
  }

  function schedule(){
    if(ticking) return;
    ticking=true;

    window.requestAnimationFrame(function(){
      ticking=false;
      run();
    });
  }

  run();

  new MutationObserver(schedule).observe(document.body,{
    childList:true,
    subtree:true
  });

  document.addEventListener("change",schedule,true);
  document.addEventListener("input",schedule,true);
  document.addEventListener("click",function(event){
    if(event.target.closest('input[type="radio"][data-variant-id],select,input[name="id"]')){
      schedule();
    }
  },true);
})();